<template>
    <div class='payment-choice'>
        <template v-if='load'>
            <table class="tableOne" cellspacing="0" cellpadding="0">
                <tr class="title">
                    <td colspan="2">
                        <div class="logo">
                            <img :src="showPay.isok?'https://cdn.dohwg.cn/images/MICE/ot/2023/04/96431FD2D328C9371E4F43F987B35F5BC34CF7EB5CD8D1DD1B8CA1BC86567294E7BEEB00AB98D478EF84140F1077DC5392ED5DDF514AC950':'https://cdn.dohwg.cn/images/MICE/ot/2023/04/96431FD2D328C9371E4F43F987B35F5B752C455112E29216CC226D91B02DA608BACBCDED84306B90FAD16517A02AEB807DE90DDC1F926876'">
                        </div>
                        <p class="success" v-if="showPay.isok">支付成功<br><span>Payment Success</span></p>
                        <p class="failure" v-else>支付失败<br><span>Payment Failure</span></p>
                    </td>
                </tr>
                <tr>
                    <td>订单号<p>(Order No.) :</p></td>
                    <td>{{showPay.no}}</td>
                </tr>
                <tr v-if="Orders.length">
                    <td colspan="2">
                        <p>订单详情(Order No.) :</p>
                        <div class="p-item" v-for="(item,OrdersIndex) in Orders" :key="OrdersIndex">
                            <div>{{item.RoomName || item.ProductName}}<span v-if='!item.IsRoom'>&nbsp;×&nbsp;{{item.Qty}}</span></div>
                            <div>￥{{item.Price * (item.Qty || 1)}}</div>
                        </div>
                    </td>
                </tr>
                <tr v-if="showPay.date!=null">
                    <td>订单时间<p>(Order time) :</p></td>
                    <td>{{showPay.date}}</td>
                </tr>
                <tr v-if="showPay.method!=null">
                    <td>支付方式<p>(Payment method) :</p></td>
                    <td>{{showPay.method}}</td>
                </tr>
                <tr v-if="showPay.amount!=null">
                    <td>订单金额<p>(Order amount) :</p></td>
                    <td>￥{{showPay.amount}}</td>
                </tr>
                <tr v-if="showPay.payamount!=null">
                    <td>支付金额<p>(Pay amount) :</p></td>
                    <td>￥{{showPay.payamount}}</td>
                </tr>
                <tr v-if='!showPay.isok&&showPay.msg!=null'>
                    <td>错误信息<p>(Error Message) :</p></td>
                    <td>{{showPay.msg}}</td>
                </tr>
            </table>
            <div class="foot">
				<Button @click='goPay(0)' size='large' class='pay-btn' type='primary' v-if='!showPay.isok && goPayText'>{{ goPayText }}</Button>
				<Button @click='goPay(1)' size='large' class='pay-btn' type='primary' v-if="goPersonalText">{{ goPersonalText }}</Button>
				<Button @click='goPay(2)' size='large' class='pay-btn' type='primary' v-if="goOtherText">{{ goOtherText }}</Button>
			</div>
        </template>
        <template v-else>
            <div class="overtime">页面超时......</div>
        </template>
    </div>
</template>
<script>
export default {
    props:{
        OrderStatus:{
            type: Array,
            default: function () {
                return [];
            }
        },
        Orders:{
            type: Array,
            default: function () {
                return [];
            }
        },
        goPayText:{
            type: String,
            default:''
        },
        goPersonalText:{
            type: String,
            default:''
        },
        goOtherText:{
            type: String,
            default:''
        },
    },
    data() {
        return {
            load: false,
            showPay:{
                isok: false,
                no: null,
                date: null,
                amount: null,
                payamount:null,
                method: null,
                msg: null,
            },
            resultOrder:null,
        }
    },
    computed: {
    },
    methods: {
        convertDate(date){
            if(date){
                let getDate = date.replace("T", " ");
                if(getDate){
                    getDate = getDate.substring(0,19);
                    return getDate;
                }
            }else{
                return null;
            }
        },
        getPayChannel(name){
            let payChannel = name.toLowerCase()
            switch (payChannel) {
                case 'together':
                    this.showPay.method = '扫码支付'
                    break
                case 'union':
                    this.showPay.method = '银联支付'
                    break
                case 'wechat':
                    this.showPay.method = '微信支付'
                    break
                case 'wechatapp':
                    this.showPay.method = '微信支付'
                    break
                case 'wechatofficialaccoun':
                    this.showPay.method = '微信支付'
                    break
                case 'alipay':
                    this.showPay.method = '支付宝支付'
                    break
                case 'unionapp':
                    this.showPay.method = '云闪付'
                    break
                case 'balancepay':
                    this.showPay.method = 'do惠支付'
                    break
                default:
                    this.showPay.method = this.$route.query.payChannel;
                    break
            }
        },
        getType(isok){
            return isok ? 'success' : 'error'
        },
        async getquerypay() {
            if (this.$route.query.code == 1) this.showPay.isok = true;
            if(this.$route.query.v_oid) this.showPay.no = this.$route.query.v_oid.split('_')[0]
            if(this.$route.query.v_orderdate) this.showPay.date = this.convertDate(this.$route.query.v_orderdate)
            if(this.$route.query.v_amount) this.showPay.amount = this.$route.query.v_amount;
            if(this.$route.query.v_payamount) this.showPay.payamount = this.$route.query.v_payamount;
            if(this.$route.query.payChannel) this.getPayChannel(this.$route.query.payChannel)
            if(this.$route.query.message) this.showPay.msg = this.$route.query.message;
        },
        goPay(num) {
            this.$emit("go",num);
        },
    },
    mounted() {
        this.$nextTick(function() {
            this.getquerypay()
            this.load = true
        })
    },
    watch:{
        OrderStatus:{
            handler(newVal,oldval) {
                if(newVal && newVal.length){
                    setTimeout(() => {
                        if(newVal[0].PaidDate) this.showPay.date = this.convertDate(newVal[0].PaidDate)
                        if(newVal[0].Amount) this.showPay.amount = newVal[0].Amount;
                        if(newVal[0].PayAmount) this.showPay.payamount = newVal[0].PayAmount;
                        if(newVal[0].Channel) this.getPayChannel(newVal[0].Channel)
                    }, 1000);
                }
            },
            immediate: true,
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/mixin';
.payment-choice{
    padding-top: 80px;
    width: 50%;
    margin: auto;
    overflow: hidden;
    text-align: center;
    @include fontSize($font-size-16);
    .tableOne{
        width: 100%;
        color: #333333;
        overflow: hidden;
        margin: 20px auto 40px auto;
        @include fontSize($font-size-16);
        .logo{
            margin-top: 30px;
            margin-bottom: 10px;
            text-align: center;
            img{
                width: 30%;
                max-width: 160px;
            }
        }
        tr{
            td{
                width: 50%;
                padding: 18px 10px;
                border-bottom: 1px solid #eeeeee;
                p{
                    display: inline;
                }
                .p-item {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 10px;
                    @include fontSize($font-size-14);
                    margin-top: 18px;
                }
            }
        }
        td:nth-child(1){
            text-align: left;
        }
        td:nth-child(2){
            text-align: right;
        }
        tr.title td{
            text-align: center;
            font-size: 24px;
            font-weight: 600;
            .success{
                color:#83b243;
                font-size: 20px;
            }
            .failure{
                color:#ed3f14;
                font-size: 20px;
            }
        }
        .noBorder td{
            border-bottom: none;
        }
    }
    .overtime{
        line-height: calc(100vh - 160px);
    }
}
.bottom {
		display:flex;
		margin:40px 0;
		justify-content: center;
		.pay-btn {
			width:330px;
			border-radius: 30px;
			height:50px;
		}
	}
.foot{
    display:flex;
    margin: 40px 0;
    flex-direction: column;
    justify-content: center;
    .pay-btn {
        width:100%;
        border-radius: 30px;
        height:50px;
    }
    .pay-btn:not(:first-child) {
        margin-top: 20px;
    }
}
@media (max-width: 768px){
    .payment-choice{
        width: 100%;
        padding: 0px 2vw;
        .tableOne{
            margin: 0px auto 10px auto;
            padding: 10px;
            font-size: 12px;
            background-color: #ffffff;
            border-radius: 20px;
            clear: both;
            box-shadow: 0.5px 1px 1px rgba(0, 0, 0, 0.2);
            .logo{
                margin: 0px;
                margin-bottom: 10px;
            }
            tr{
                td{
                    line-height: 20px;
                    padding: 10px 6px;
                    border-bottom: 1px dashed #e5e5e5;
                    p{
                        display: block;
                        margin: 0;
                    }
                }
            }
            tr:first-child,tr:last-child{
                td{
                    border-bottom: none;
                }
            }
            td:nth-child(1){
                text-align: left;
                font-weight: 600;
            }
            td:nth-child(2){
                text-align: right;
            }
            tr.title td{
                padding: 0px 6px 10px 6px;
                .success{
                    font-size: 18px;
                }
                .failure{
                    font-size: 18px;
                }
            }
        }
        .overtime{
            line-height: 30px;
        }
    }
    .foot{
        .pay{
            margin-bottom:10px;
        }
    }
}
</style>